import { createSelector } from 'reselect';

const globalState = (state) => state.get('globalState');

export const hasUnReadMessage = createSelector(globalState, (globalState) => globalState.get('hasUnReadMessage'));

export const hasNewFriend = createSelector(globalState, (globalState) => globalState.get('hasNewFriend'));
